import { FILTER_CLEAR_BTN_CLASS, FILTER_INPUT_CLASS } from '../constants/filterBar';

/**
 * Search field for list filter bars — same height as MultiSelectFilter triggers.
 */
export default function FilterSearchField({
  value,
  onChange,
  placeholder,
  onClear,
  showClear = true
}) {
  const handleClear = () => {
    onChange?.({ target: { value: '' } });
    onClear?.();
  };

  return (
    <div className="flex items-center gap-2 min-w-0 h-9 w-full">
      <input
        type="text"
        className={FILTER_INPUT_CLASS}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
      {showClear && value ? (
        <button
          type="button"
          className={FILTER_CLEAR_BTN_CLASS}
          onClick={handleClear}
          title="Clear search"
          aria-label="Clear search"
        >
          ✕
        </button>
      ) : null}
    </div>
  );
}
